
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.621 13.556a1.99 1.99 0 001.989 1.987 1.99 1.99 0 001.988-1.988 1.992 1.992 0 00-1.988-1.988 1.99 1.99 0 00-1.989 1.989zm1.15 0a.84.84 0 111.679 0 .84.84 0 01-1.68 0z","fill":"#A4A8C0"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.64 12.881v5.344a.571.571 0 010 .105v.79c0 2.704-1.741 4.522-4.332 4.522h-6.622c-2.588 0-4.328-1.818-4.328-4.522v-6.24c0-2.704 1.74-4.522 4.328-4.522h6.625c1.232 0 2.294.412 3.072 1.19.812.814 1.258 1.997 1.256 3.333zm-14.133 0c0-2.05 1.248-3.374 3.18-3.374h6.624c.921 0 1.701.295 2.26.853.603.605.921 1.476.92 2.52v4.027c-.787-.698-1.823-1.4-2.968-1.4-1.043 0-1.755 1.001-2.382 1.886l-.005.008c-.45.633-.96 1.347-1.365 1.347-.445 0-.907-.194-1.397-.4-.831-.35-1.864-.784-2.822.005-.707.582-1.377 1.489-1.82 2.157a4.132 4.132 0 01-.225-1.39v-6.24zm10.016 3.774c1.132 0 2.3 1.163 2.968 1.852v.613c0 2.05-1.25 3.373-3.183 3.373h-6.622c-.95 0-1.735-.32-2.288-.891.35-.57 1.113-1.727 1.883-2.362.386-.317.78-.2 1.648.166.546.23 1.165.491 1.842.491 1 0 1.664-.935 2.306-1.839l.005-.007c.466-.656.993-1.396 1.441-1.396z","fill":"#A4A8C0"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zM1.433 16C1.433 7.955 7.955 1.433 16 1.433S30.567 7.955 30.567 16 24.045 30.567 16 30.567 1.433 24.045 1.433 16z","fill":"#A4A8C0"}})])
          )
        }
      }
    